import type { ComponentProps, RefObject } from "react";
import type { DatePicker } from "@ark-ui/react";
import Wrapper from "./Wrapper";
import DayView from "./DayView";
import MonthView from "./MonthView";
import YearView from "./YearView";

type Props = Omit<ComponentProps<typeof DatePicker.Content>, "children"> & {
  container?: RefObject<HTMLElement>;
  usePortal?: boolean;
};

const Content = ({ className, container, usePortal = true, ...rest }: Props) => {
  return (
    <Wrapper container={container} usePortal={usePortal} className={className} {...rest}>
      <DayView />
      <MonthView />
      <YearView />
    </Wrapper>
  );
};

export default Content;
